import * as React from "react";
import { cn } from "./utils";

/**
 * Small ghost icon button used inside a field: clear, show password, search clear.
 * Matches the combobox clear control (icon-xs, no border, muted until hover).
 */
export function FieldIconButton({ className, type = "button", ...props }: React.ComponentProps<"button">) {
    return (
        <button
            type={type}
            className={cn(
                "inline-flex justify-center items-center hover:bg-accent disabled:opacity-50 p-0 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 size-6 [&_svg]:size-4 text-muted-foreground hover:text-foreground [&_svg]:pointer-events-none disabled:pointer-events-none shrink-0",
                className
            )}
            {...props}
        />
    );
}
